import { usePermissions } from './usePermissions';
import { UserRolesTypes } from '../../models';

export const useUserHasRoles = (...roles: UserRolesTypes[]): boolean => {
  const { canRender } = usePermissions();

  return canRender(roles);
};
